module.exports = __webpack_public_path__ + "static/case-hp-02-b343522f011cff213c0cb2119619ed66.jpg";